import { getSyiSlice } from 'tradera-state/views/syi/selectors/syi';

export default {
    toggleAllVisible: () => dispatch => {
        dispatch({
            type: 'TOGGLE_ALL_VISIBLE'
        });
    },
    togglePaymentOption: paymentOption => (dispatch, getState) => {
        paymentOption.selected = !paymentOption.selected;
        var selectedPaymentOptions = [];
        if (
            Array.isArray(
                getSyiSlice(getState()).payment.selectedPaymentOptions
            )
        ) {
            selectedPaymentOptions = getSyiSlice(
                getState()
            ).payment.selectedPaymentOptions.slice();
        }

        if (paymentOption.selected) {
            selectedPaymentOptions.push(paymentOption.paymentType);
        } else {
            selectedPaymentOptions = selectedPaymentOptions.filter(
                po => po != paymentOption.paymentType
            );
        }
        selectedPaymentOptions = selectedPaymentOptions.filter(
            po => po != null
        );

        dispatch({
            type: 'SET_PAYMENT_OPTIONS',
            selectedPaymentOptions: selectedPaymentOptions
        });
    },
    setSelectedPaymentOptions: selectedPaymentOptions => dispatch => {
        dispatch({
            type: 'SET_PAYMENT_OPTIONS',
            selectedPaymentOptions: selectedPaymentOptions
        });
    },
    reset: () => dispatch => {
        dispatch({
            type: 'SET_PAYMENT_OPTIONS',
            selectedPaymentOptions: []
        });
    }
};
